import { useArticleStatuses } from '@/store/article-statuses';
import { assertUnreachable } from '@lib/type-helpers';
import { useColorStatuses } from '@/store/color-statuses';
import { useColorPaletteStatuses } from '@/store/color-palette-statuses';
import { useComponentStatuses } from '@/store/component-statuses';
import { useOrderStatuses } from '@/store/order-statuses';
import { useMChartStatuses } from '@/store/mchart-statuses';
import { useMeasurementStatuses } from '@/store/measurement-statuses';
import { useSampleStatuses } from '@/store/sample-statuses';
import { useSupplierStatuses } from '@/store/supplier-statuses';
import { useTags } from '@/store/tags';
import { useComponentTags } from '@/store/component-tags';
import { useMChartTags } from '@/store/mchart-tags';
import { useOrderTags } from '@/store/order-tags';
import { usePlacementTags } from '@/store/placement-tags';
import { useProductImageTags } from '@/store/product-image-tags';
import type {
  ArticleStatusDto,
  BrandSupplierStatusDto,
  ColorStatusDto,
  ColorPaletteStatusDto,
  ComponentStatusDto,
  ComponentTagDto,
  MChartStatusDto,
  MChartTagDto,
  OrderStatusDto,
  OrderTagDto,
  PlacementTagDto,
  ProductImageTagDto,
  SampleStatusDto,
  MeasurementStatusDto,
  TagDto,
} from '@/ApiClient';

export type StatusTypes = {
  article: ArticleStatusDto;
  component: ComponentStatusDto;
  order: OrderStatusDto;
  mchart: MChartStatusDto;
  sample: SampleStatusDto;
  measurement: MeasurementStatusDto;
  supplier: BrandSupplierStatusDto;
  color: ColorStatusDto;
  colorPalette: ColorPaletteStatusDto;
};
export type StatusType = keyof StatusTypes;

export function useStatusStore(type: StatusType) {
  if (type === 'article') return useArticleStatuses();
  if (type === 'component') return useComponentStatuses();
  if (type === 'order') return useOrderStatuses();
  if (type === 'mchart') return useMChartStatuses();
  if (type === 'sample') return useSampleStatuses();
  if (type === 'measurement') return useMeasurementStatuses();
  if (type === 'supplier') return useSupplierStatuses();
  if (type === 'color') return useColorStatuses();
  if (type === 'colorPalette') return useColorPaletteStatuses();

  assertUnreachable(type);
}

export type TagTypes = {
  product: TagDto;
  component: ComponentTagDto;
  mchart: MChartTagDto;
  order: OrderTagDto;
  placement: PlacementTagDto;
  productImage: ProductImageTagDto;
};
export type TagType = keyof TagTypes;
export type TagTypeDto = TagTypes[TagType];

export function useTagStore(type: TagType) {
  if (type === 'product') return useTags();
  if (type === 'component') return useComponentTags();
  if (type === 'mchart') return useMChartTags();
  if (type === 'order') return useOrderTags();
  if (type === 'placement') return usePlacementTags();
  if (type === 'productImage') return useProductImageTags();

  assertUnreachable(type);
}
